'use client'
import { listDocs } from '@/app/api';
import { H2, Spinner } from '@/components/ui';
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'
import { swaggerColorStyles } from './swagger-color-styles';
import { useTheme } from 'next-themes';
import { useState, useEffect } from 'react';

export function DocsTable() {
    const { resolvedTheme } = useTheme();
    const [spec, setSpec] = useState<any>(null);

    const currentTheme = resolvedTheme || 'light';

    useEffect(() => {
        async function fetchSpec() {
            const result = await listDocs();
            setSpec(result.data);
        }
        fetchSpec();
    }, []);

    if (!spec)
        return (
            <div className='pt-8 flex gap-2 justify-center items-center text-center'>
                <Spinner className="size-6" />
                <H2>Carregando documentação...</H2>
            </div>
        )

    return (
        <div className={`pt-8 ${currentTheme === 'dark' ? 'dark' : ''}`}>
            <style>{swaggerColorStyles}</style>
            <SwaggerUI
                spec={spec}
                tryItOutEnabled={true}
                displayOperationId={true}
                docExpansion="none"
                displayRequestDuration={true}
                filter={false}
            />
        </div>
    )
}